import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.dark,
  },

  formHelperText: {
    marginLeft: "0px",
    position: "absolute",
    bottom: "-20px",
  },
  subtitle: {
    color: theme.palette.primary.dark,
    fontSize: "1.4rem",
  },

  saveButton: {
    marginLeft: theme.spacing(2),
  },
  textfield: {
    marginTop: theme.spacing(2),
  },
  makeAdmin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.dark,
  },
}))

export default styles
